import { render, staticRenderFns } from "./editComicChapter.vue?vue&type=template&id=b898ba9c&scoped=true"
import script from "./editComicChapter.vue?vue&type=script&lang=js"
export * from "./editComicChapter.vue?vue&type=script&lang=js"
import style0 from "./editComicChapter.vue?vue&type=style&index=0&id=b898ba9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b898ba9c",
  null
  
)

export default component.exports